'use client'
import { Button, Icon } from '@shc/ui'
import { type ComponentPropsWithoutRef } from 'react'
import NextLink from 'next/link'
import { AnalyticsLink } from '@components/analytics'
import useAnalytics from '@hooks/use-analytics'
export interface NewsShareButtonsProps extends ComponentPropsWithoutRef<'div'> {
  shareTitle: string
  shareUrl: string
  facebook?: boolean
  twitter?: boolean
  email?: boolean
  emailBody?: string
  print?: boolean
}

const NewsShareButtons = ({
  shareTitle,
  shareUrl,
  facebook = false,
  twitter = false,
  email = false,
  emailBody = '',
  print = false,
  className,
  children,
  ...props
}: NewsShareButtonsProps) => {
  const { trackSnowplow } = useAnalytics()
  const printScreen = () => {
    trackSnowplow({
      event: { name: 'component_click', data: {} },
      contexts: [
        {
          name: 'component',
          data: { component_text: 'Print' },
        },
      ],
    })
    window.print()
    return false
  }

  return (
    <div className={className} {...props}>
      <ul className="flex flex-row gap-x-2 justify-left">
        {facebook && (
          <li>
            <AnalyticsLink
              as={Button}
              asPassthru={NextLink}
              href={'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl)}
              size="xs"
              shape="circle"
              width="auto"
              variant="outlined"
              title="Facebook"
              aria-label="Share via Facebook"
              target="_blank"
              rel="noreferrer noopener">
              <Icon icon={['fab', 'facebook-f']} className="h-4" />
            </AnalyticsLink>
          </li>
        )}
        {twitter && (
          <li>
            <AnalyticsLink
              as={Button}
              asPassthru={NextLink}
              href={
                'https://x.com/intent/tweet?text=' +
                encodeURIComponent(shareTitle) +
                '&url=' +
                encodeURIComponent(shareUrl) +
                '&via=sharphealthcare'
              }
              size="xs"
              shape="circle"
              width="auto"
              variant="outlined"
              title="Twitter"
              aria-label="Share via Twitter"
              target="_blank"
              rel="noreferrer noopener">
              <Icon icon={['fab', 'twitter']} className="h-4" />
            </AnalyticsLink>
          </li>
        )}
        {email && (
          <li>
            <AnalyticsLink
              as={Button}
              asPassthru={NextLink}
              href={
                'mailto:?subject=' +
                encodeURIComponent(shareTitle) +
                '&body=' +
                encodeURIComponent(emailBody)
              }
              size="xs"
              shape="circle"
              width="auto"
              variant="outlined"
              title="Email"
              aria-label="Share via email"
              target="_blank"
              rel="noreferrer noopener">
              <Icon icon="envelope" className="h-4" />
            </AnalyticsLink>
          </li>
        )}
        {print && (
          <li>
            <Button
              size="xs"
              shape="circle"
              width="auto"
              variant="outlined"
              title="Print"
              target="_blank"
              rel="noreferrer noopener"
              onClick={printScreen}>
              <Icon icon="print" className="h-4" />
            </Button>
          </li>
        )}
      </ul>
      <div className="empty:hidden">{children}</div>
    </div>
  )
}

export default NewsShareButtons
